import { fromJS, is } from 'immutable';
import { isImmutable } from 'pluginServices/helpers/immutableHelpers';

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function compareObject(a, b) {
  const aIsJSONOrObject = isJson(a) || typeof a === 'object';
  const bIsJSONOrObject = isJson(b) || typeof b === 'object';

  if (aIsJSONOrObject !== bIsJSONOrObject) {
    return false;
  }

  if (!aIsJSONOrObject && !bIsJSONOrObject) {
    return a === b;
  }

  const aObject = typeof a !== 'string' ? a : JSON.parse(a);
  const bObject = typeof b !== 'string' ? b : JSON.parse(b);

  const aImmutable = isImmutable(aObject) ? aObject : fromJS(aObject);
  const bImmutable = isImmutable(bObject) ? bObject : fromJS(bObject);

  return is(aImmutable, bImmutable);
}
